import BaseRequest from '../_baseRequest';
import moment from 'moment';

const baseUrl = 'Promemoria';

const PromemoriaService = {
  operations: (PageNum = undefined, PageSize = undefined) => {
    const req = new BaseRequest();
    let params = undefined;
    if (PageNum && PageSize) {
      params = { PageNum, PageSize };
    }
    return req.makeRequest(
      params,
      {},
      null,
      'get',
      '/api/' +
        baseUrl +
        '?PageNum=1&PageSize=5&flagDiffusione=1&dateTime=' +
        moment().format('YYYY-MM-DD'),
      null,
      null,
      null,
      false,
      false,
      'AZURE'
    );
  }
};

export default PromemoriaService;
